<h2>Modification Utilisateur</h2>
<div class="d-flex">
  <div class="user-form">
    <form [formGroup]="userCreationForm" (ngSubmit)="onSubmit(userCreationForm.value)">
      <div class="form-row mt-4">
        <div class="form-group col-md-5">
          <label for="firstname">Prénom:</label>
          <input class="form-control" id="firstname" name="firstname" [value]="currentUser?.username" formControlName="username">
        </div>
        <div class="form-group col-md-5 offset-md-1">
          <label for="lastname">Nom:</label>
          <input class="form-control" id="lastname" name="lastname" [value]="currentUser?.lastname" formControlName="lastname">
        </div>
      </div>
      <div class="form-row mt-5">
        <div class="form-group col-md-10">
          <label for="email">Email:</label>
          <input class="form-control" id="email" name="email" [value]="currentUser?.email" formControlName="email">
        </div>
      </div>
      <div class="form-row mt-5">
        <div class="form-group col-md-5">
          <label for="concessions">Concessions:</label>
          <ng-multiselect-dropdown id="concessions" name="concessions" [ngModelOptions]="{standalone: true}"
                                   [placeholder]="'Select'"
                                   [data]="dropdownConcessionList"
                                   [(ngModel)]="selectedConcession"
                                   [settings]="dropdownSettings"
                                   (onSelect)="onConcessionSelect($event)"
                                   (onDeSelect)="onConcessionDeselect($event)"
          >
          </ng-multiselect-dropdown>
          <small *ngIf="errors.concessions" class="input-error" style="color: red">Champ requis</small>
        </div>
        <div class="form-group col-md-5 offset-md-1">
          <label for="roles">Roles:</label>
          <ng-multiselect-dropdown id="roles" name="roles" [ngModelOptions]="{standalone: true}"
                                   [placeholder]="'Rôles'"
                                   [data]="dropdownRolesList"
                                   [(ngModel)]="selectedRoles"
                                   [settings]="dropdownSettings"
                                   (onSelect)="onRoleSelect($event)"
                                   (onDeSelect)="onRoleDeselect($event)"
          >
          </ng-multiselect-dropdown>
          <small *ngIf="errors.role" class="input-error" style="color: red">Champ requis</small>
        </div>
      </div>

      <div class="form-row mt-5" *ngIf="hasRoleIspacc()">
        <div class="form-group col-md-11">
          <label for="ispacc_right_level">Niveau de droits Ispa-CC :</label>
          <div class="border rounded p-3 mt-1">
            <div class="d-flex align-items-center">
              <input type="checkbox" id="ispacc_right_level" name="ispacc_right_level" [value]="currentUser?.ispacc_right_level" formControlName="ispacc_right_level">
              <span class="ml-2" style="font-size: 12px;">Droit à l'importation de fichier de type <strong>"Commerciale"</strong>.</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Exclusions notifications -->
      <div class="form-row mt-5" *ngIf="hasRoleKIDI() || hasRolePMESSAGE() || hasRolePWHEELER()">
        <div class="form-group col-md-11">
          <label>Exclusions de notifications :</label>
          <div class="border rounded p-3 mt-1 notification-exclusions">
            <div *ngIf="hasRoleKIDI()" class="d-flex align-items-center mb-2">
              <input type="checkbox" id="exclude_kidi" [(ngModel)]="notificationExclusions.KIDI" [ngModelOptions]="{standalone: true}">
              <span class="ml-2" style="font-size: 12px;">Exclure l'utilisateur des notifications <strong>"KIDI"</strong></span>
            </div>
            <div *ngIf="hasRolePMESSAGE()" class="d-flex align-items-center mb-2">
              <input type="checkbox" id="exclude_pmessage" [(ngModel)]="notificationExclusions.PMESSAGE" [ngModelOptions]="{standalone: true}">
              <span class="ml-2" style="font-size: 12px;">Exclure l'utilisateur des notifications <strong>"Pilot'Message"</strong></span>
            </div>
            <div *ngIf="hasRolePWHEELER()" class="d-flex align-items-center mb-2">
              <input type="checkbox" id="exclude_pwheeler" [(ngModel)]="notificationExclusions.PWHEELER" [ngModelOptions]="{standalone: true}">
              <span class="ml-2" style="font-size: 12px;">Exclure l'utilisateur des notifications <strong>"Pilot-wheeler"</strong></span>
            </div>
          </div>
        </div>
      </div>

      <div class="form-row mt-5" *ngIf="currentUser?.auth_two_factor_secret">
        <div class="form-group col-md-11">
          <div class="d-flex"><div>Authenticator configuré </div><div (click)="resetOtpSecret()" matTooltip="Réinitialiser le secret" class="text-danger ml-2 pointer"><mat-icon>delete</mat-icon></div></div>
        </div>
      </div>
      <div class="btn-pannel">
        <div>
          <button type="submit" class="btn btn-dark btn100px btn-create p-2 mr-2">Modifier</button>
        </div>
        <div>
          <button class="btn btn-light border-dark btn100px btn-create p-2" type="button" routerLink="/gestion-utilisateur">Annuler</button>
        </div>
      </div>
    </form>
  </div>
  <div class="d-flex flex-wrap">
    <div class="concession-list m-4">
      <h4>Concessions Actives:</h4>
      <div *ngFor="let concession of selectedConcession">{{ concession.item_text }}</div>
    </div>
    <div class="concession-list m-4">
      <h4>Rôles actifs:</h4>
      <div *ngFor="let role of selectedRoles">{{ role.item_text }}</div>
    </div>
  </div>
</div>
